import React, { useState, useEffect } from "react";
import {
  TOTAL_SCREENS,
  GET_SCREEN_INDEX,
} from "../../../Utilities/commonUtils";
import ScrollService from "../../../Utilities/ScrollService";
import useTheme from "../../../Utilities/useTheme";
import "./Header.css";

export default function Header() {
  const [selectedScreen, setSelectedScreen] = useState(0);
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { theme, toggleTheme } = useTheme();

  // Handle scroll effect for the header
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const subscription = ScrollService.currentScreenBroadcaster.subscribe(
      (currentScreen) => {
        if (!currentScreen || !currentScreen.screenInView) return;
        let screenIndex = GET_SCREEN_INDEX(currentScreen.screenInView);
        if (screenIndex < 0) return;
        setSelectedScreen(screenIndex);
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  const getHeaderOptions = () => {
    return TOTAL_SCREENS.map((Screen, i) => (
      <button
        key={Screen.screen_name}
        className={getHeaderOptionsClasses(i)}
        onClick={() => switchScreen(i, Screen)}
        aria-current={selectedScreen === i ? "true" : undefined}
      >
        <span>{Screen.screen_name}</span>
      </button>
    ));
  };

  const getHeaderOptionsClasses = (index) => {
    let classes = "header-option ";
    if (selectedScreen === index) classes += "selected-header-option ";
    return classes;
  };

  const switchScreen = (index, screen) => {
    let screenComponent = document.getElementById(screen.screen_name);
    if (!screenComponent) return;

    screenComponent.scrollIntoView({ behavior: "smooth" });
    setSelectedScreen(index);
    setShowHeaderOptions(false);
  };

  const toggleMenu = () => {
    setShowHeaderOptions(!showHeaderOptions);
  };

  return (
    <header className={`header-container ${isScrolled ? "scrolled" : ""}`}>
      <nav className="header-parent" aria-label="Navigation principale">
        <div className="header-logo">
          <span>SOULEIMANE<span className="header-logo-accent">Z</span></span>
        </div>

        <div className="header-right">
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "Passer au thème clair" : "Passer au thème sombre"}
          >
            {theme === "dark" ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
            )}
          </button>

          <button
            className="header-hamburger"
            onClick={toggleMenu}
            aria-label="Menu de navigation"
            aria-expanded={showHeaderOptions}
            aria-controls="header-nav-options"
          >
          <div className={`hamburger-icon ${showHeaderOptions ? "open" : ""}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        </div>

        <div
          id="header-nav-options"
          className={showHeaderOptions ? "header-options show-hamburger-options" : "header-options"}
          role="menubar"
        >
          {getHeaderOptions()}
        </div>
      </nav>
    </header>
  );
}